var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"realLazyImg",staticClass:"real-lazy-img"},[(_vm.url)?_c('LazyImg',{staticClass:"book-page-img",attrs:{"src":_vm.ossProcessImgWebp(_vm.url, _vm.imageSize.width, _vm.imageSize.height)},on:{"onLoadImg":_vm.onLoadImg,"onLoadError":_vm.onLoadError}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }